import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../globals';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { TPVServices } from '../../tpv/services';
import { OrdersCoServices } from '../../orders/services';
import { CustomersServices } from '../../customers/services';
import { SearchServices } from '../../services/searchs';

/**
 * Generated class for the  page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-selected-persons',
  templateUrl: 'selected-persons.html',
})
export class SelectedPersonsPage {

  origin: any;
  update: any;
  public firestore: any;
  numPersons: number;
  table_uid: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public afs: AngularFirestore,
    public tpvServices: TPVServices,
    public ordersCoServices: OrdersCoServices,
    public customersServices: CustomersServices,
    public searchServices: SearchServices) {

    this.firestore = firebase.firestore();
    this.origin = this.navParams.get('origin');
    this.update = this.navParams.get('update');
  }

  ionViewDidLoad() {
    if (this.origin == 'tpv') {
      this.table_uid = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID;
    } else {
      this.table_uid = this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID;
    }
  }

  addNumPersons(number) {
    if (this.numPersons) {
      var help = this.numPersons.toString();
      this.numPersons = parseInt(help.concat(number));
    } else {
      this.numPersons = number;
    }

  }

  async selectPersons() {
    if (this.origin === 'orders') {//orders
      //number persons
      this.ordersCoServices.tableUpdatePersons(this.numPersons);
      this.numPersons = null;
      //customer
      if (this.ordersCoServices.selectedPersonId) {
        var customer = await this.customersServices.getCustomer(this.ordersCoServices.selectedPersonId);
        this.ordersCoServices.tableUpdateCustomer(customer);
        this.ordersCoServices.selectedPersonId = null;
        //Guardamos el comentario en el service
        this.ordersCoServices.customer_note = customer.note;
      } else {
        this.ordersCoServices.customer_note = "";
      }
      //Actualizamos el created_at para la hora de entrada
      if (!this.update) {
        var _ticket = this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].ticket;
        this.afs.collection('tables').doc(this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID).update({
          ticket: {
            amount: _ticket.amount,
            payment: _ticket.payment,
            payment_type: _ticket.payment_type,
            date: _ticket.date,
            number: _ticket.number,
            waiter: _ticket.waiter,
            waiter_uid: _ticket.waiter_uid,
            list: _ticket.list,
            tip: _ticket.tip || 0,
            created_at: new Date(),
            updated_at: new Date(),
          },
        });
      }

    } else {//tpv
      //number persons
      this.tpvServices.tableUpdatePersons(this.numPersons);
      this.numPersons = null;
      //customer
      if (this.tpvServices.selectedPersonId) {
        var customer_tpv = await this.customersServices.getCustomer(this.tpvServices.selectedPersonId);
        this.tpvServices.tableUpdateCustomer(customer_tpv);
        this.tpvServices.selectedPersonId = null;
      }

    }
    this.close();
  }

  clear() {
    this.numPersons = null;
    this.ordersCoServices.selectedPersonId = null;
    this.tpvServices.selectedPersonId = null;
    this.clearSearchCustomers();
  }

  close() {
    this.clearSearchCustomers();
    this.viewCtrl.dismiss();
  }

  fullHeight(value) {
    if (value) {
      let cssClasses = {
        'height-100': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'height-100': false,
      }
      return cssClasses;
    }
  }

  clearSearchCustomers() {
    this.searchServices.selectedPersonId = '';
    this.searchServices.customer_data = '';
    this.searchServices.customer_search = '';
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/selected-persons/selected-persons.ts